import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

/**
 * Calculates elapsed seconds between a given UTC datetime and now.
 * Handles invalid or future times gracefully.
 * @param answerAt - ISO UTC timestamp when call was answered
 * @returns Number of seconds since the call was answered
 */
export const getElapsedSecondsFromCallDate = (answerAt)=> {
    if (!answerAt) return 0

    const now = dayjs.utc()
    const start = dayjs.utc(answerAt)

    const diff = now.diff(start, 'second')
    return diff > 0 ? diff : 0
}
